import { BaseClass } from './base-class';

export abstract class BaseComponent extends BaseClass {
    constructor() {
        super();
    }
}
